/* eslint react/no-string-refs: "off" */

import React from 'react';
import * as _ from 'lodash';
import moment from 'moment';
import FieldTreeMain from '../components/FieldTreeMain';
import FieldTreePagination from '../components/FieldTreePagination';
import EventMg from '../utilities/EventManager';
import dialogLoader from '../utilities/dialogLoader';
import { navigationDelegate } from '../utilities/navigationDelegate';
import { LayoutManager } from '../utilities/layoutManager';
import { heightDelegate } from '../utilities/heightDelegate';
import { DropdownMultiSelect } from '../utilities/formComponents';
import { JSDropdownMultiSelect } from '../components/JSDropdown';
import * as api from '../services/FieldTree';
import * as dialog from '../components/FieldTreeDialog';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { FIELD_TREE_EVENTS } from '../components/FieldTreeEvents';
import urlParamManager from '../utilities/urlParamManager';
import {
  HEADER_CONSTANTS,
  APPROVAL_STATUS_FIELDTREE,
  CSV_TYPE,
  USER_ROLES,
  CCUS_STATUS_DISPLAY_TOGGLE,
  EXECUTION_STATUS,
  DIALOG_TYPE_INFO,
  DIALOG_TYPE_CONFIRM,
  API_FLAG,
  ENTER_WORKER_FIELD_TREE_ID_PARAM_NAME,
} from '../utilities/constants';
import {
  csvDownloader,
  isApiFlagOff,
  isIPad,
  getQueryStringParameter,
  redirectToGreenfileSagyouinEditIfFromGreenfile,
} from '../utilities/commonUtil';
import {
  isLoginUserPartnerCompany,
  isLoginUserPrimaryCompany,
  isPartnerRoleId,
  isPrimaryCompanyRoleId,
  isPrimeRoleId,
} from '../utilities/roleUtility';
import SessionStorageService from '../services/utilities/SessionStorageService';
import PrimeContractorButton from '../components/button/PrimeContractorButton';
import { FieldTreeJobsDropdown } from '../components/dropdowns/multi/FieldTreeJobs';
import ForemanNewPasswordDialog, {
  DialogType,
} from '../components/dialogs/ForemanNewPasswordDialog';
import { messageUtility } from '../utilities/messageUtility';
import StaticFileService from '../services/StaticFiles';

const PAGE_EVENT = {
  SEARCH_PARAM: 'search_param',
  TEMP_SEARCH_PARAM: 'temp_search_param',
};
import Helmet from 'react-helmet';
import Confirmation from '../components/modals/common/Confirmation';
import Information from '../components/modals/common/Information';
import { MasterPageHeader } from '../components/PageHeader';
import { Description } from '../components/Description';
import { SchoolIcon } from '../components/icons/SchoolIcon';

const pendingKey = APPROVAL_STATUS_FIELDTREE.pending.key;
const invitedKey = APPROVAL_STATUS_FIELDTREE.invited.key;
const APPROVAL_DESCRIPTION_STATUS = {
  PRIMARY_PARTNER_COMPANY: 1,
  SECONDARY_PARTNER_COMPANY: 2,
};

const PRESIGN_FILES = {
  fieldTreeGuideForContractor: 'field_tree_guilde_for_contractor',
  fieldTreeGuideForPartner: 'field_tree_guilde_for_partner',
};

/**
 * @description 施工体系図画面
 */
export default class FieldTreePage extends React.Component {
  constructor(props) {
    super(props);
    //絞り込みキー
    this.paramsDefault = {
      approval_flag: null, // ステータス(承認依頼前:0 承認済:1 元請承認待:2)
      user_ids: [], // 協力会社ユーザーID
      user_names: [], // 協力会社ユーザー名
      jobs: [], // 職種
      company_branch_ids: [], // 協力会社(の支店ID)
      company_branch_names: [], // 協力会社(の支店名)
      joining_flag: null, // 元請 共通／固有
      has_foreman: null, // 管理者 あり/なし
      has_partner: null, // 職長 あり/なし
      all_box_continue: true,
      continue_and_finished: true,
      all_box_finished: true,
      show_finished_box: true,
      jv_company_branch_id: null, // JV
      only_ccus_error: false, // CCUSエラーのみ表示
      offset: 0,
      limit: 20,
    };
    // 英語としては
    // 支店 = company_branch
    // 協力会社 = partner_company で表されるのが正しいのだが
    // システムのDBの構造では、元請会社 協力会社 はどちらも同じように
    // 会社のユニークIDは company_branch_id という名前で管理されている
    // なのでここでは 協力会社 の管理に
    // company_branch_ids という変数名になる。

    this.state = {
      companyId: SessionStorageService.getCompanyId(),
      companyBranchId: SessionStorageService.getCompanyBranchId(),
      showForm: true,
      params: _.cloneDeep(this.paramsDefault),
      tempParams: _.cloneDeep(this.paramsDefault),
      field_id: SessionStorageService.getFieldId(),
      field_data: {}, //現場情報
      entities: {},
      field_trees: [],
      constructor: {},
      results: {},
      user_profile: {},
      page: props[1] || 1, // 現在表示中のページ
      lastPage: 1, //最終ページ
      refreshFlag: false, // 検索条件クリアフラグ
      isLoading: true, // ロード中フラグ
      displayCcusDialogFlg: false, // CCUS施工体制連携の成功の場合のポップアップ表示フラグ
      ccusErrorDialogFlg: false, // CCUS施工体制連携エラーダイアログフラグ
      ccusErrorMessage: '', // CCUS施工体制連携エラーメッセージ
      isCcusStateActiveFlg: true, // CCUS連携状態の表示切り替えフラグ
      ccusApiLoadingFlg: false, // CCUS施工体制連携API処理中フラグ
      fieldConnectionStatus: null, // ccus_field_tree_auto_taskのconnection_statusの値。nullの場合、施工体制連携ブロック表示しない
      autoTaskActive: null, // ccus_field_tree_auto_taskのactiveの値。nullの場合、施工体制連携ブロック表示しない
      isCcusProcessingFlg: false, // 連携中の状態フラグ
      isBeforeCcusConnectionFlg: false, // 連携開始前の状態フラグ
      partnerCompanyCanRequest: false,
      fieldTreeStatus: {
        approvalStatus: 0,
        hasPartnerCompanyPending: false,
        hasPartnerCompanyInvited: false,
      },
      isCheckedAll: {
        [pendingKey]: false,
        [invitedKey]: false,
      },
      selectedNodes: {
        [pendingKey]: [],
        [invitedKey]: [],
      },
      listNodeNotApprove: {
        [pendingKey]: [],
        [invitedKey]: [],
      },
      dialogState: {},
      isShowDialog: {
        info: false,
        confirm: false,
      },
      isUserMainJV: false,
      jvFlag: false,
    };
    this.searchForm = null;
    this.DDPartnerCompany = null;
    this.DDForeman = null;
    this.isPageLoading = false;
    this.configDialogPrimeCompany = {
      confirmApproval: {
        title: '協力会社の承認',
        message: messageUtility.getMessage('I-001-413'),
        confirmButtonText: messageUtility.getMessage('I-000-007'),
        cancelButtonText: messageUtility.getMessage('I-000-008'),
        onConfirm: () => {
          this.handleCloseDialog();
          this.approve();
        },
        onCancel: this.handleCloseDialog,
      },
      confirmReject: {
        title: '協力会社の否認',
        message: messageUtility.getMessage('I-001-423'),
        confirmButtonText: '否認',
        cancelButtonText: messageUtility.getMessage('I-000-008'),
        isNegative: true,
        onConfirm: () => {
          this.handleCloseDialog();
          this.submitRejectApproval();
        },
        onCancel: this.handleCloseDialog,
      },
      infoNotSelectNodeForApprove: {
        title: '選択した協力会社の承認',
        message:
          '元請承認待の施工体制が選択されていません。承認は元請承認待の施工体制を選択した状態で行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialog,
      },
      infoNotSelectNodeForReject: {
        title: '選択した協力会社の否認',
        message:
          '元請承認待の施工体制が選択されていません。否認は元請承認待の施工体制を選択した状態で行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialog,
      },
      infoApproveSuccess: {
        title: messageUtility.getMessage('I-000-010'),
        message: '選択した協力会社の承認が完了しました。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
      infoRejectSuccess: {
        title: '否認完了',
        message: '選択した協力会社の否認が完了しました。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
      infoApproveFailure: {
        title: '承認に失敗しました',
        message:
          '選択した協力会社の承認に失敗しました。再度、承認操作を行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
      infoRejectFailure: {
        title: '否認に失敗しました',
        message:
          '選択した協力会社の否認に失敗しました。再度、否認操作を行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
    };
    this.configDialogPartnerCompany = {
      confirmExitFieldTree: {
        title: '画面遷移に関する確認',
        message:
          '承認依頼前の施工体制があります。このまま画面遷移してもよろしいですか？',
        confirmButtonText: '画面遷移する',
        cancelButtonText: '戻って承認依頼する',
        isNegative: true,
        onConfirm: this.onConfirmDialogExitFieldTree,
        onCancel: () => {
          this.handleCloseDialog();
          this.layout.forceUpdate();
          // BLDE_V2-37215：ipadのときはタブを開かないようにする苦肉の策
          if (!isIPad()) {
            this.setState({ showForm: false });
          }
          if (this.isEmptySearchParams()) {
            this.handleChangeSearchParam(
              'approval_flag',
              APPROVAL_STATUS_FIELDTREE.invited.id
            );
          }
        },
      },
      confirmRequestApproval: {
        title: messageUtility.getMessage('I-001-424'),
        message: '選択中の協力会社の承認を元請に依頼します。よろしいですか？',
        confirmButtonText: messageUtility.getMessage('I-000-082'),
        cancelButtonText: messageUtility.getMessage('I-000-008'),
        onConfirm: () => {
          this.handleCloseDialog();
          this.submitRequestApproval();
        },
        onCancel: this.handleCloseDialog,
      },
      requestApprovalEmpty: {
        title: messageUtility.getMessage('I-001-424'),
        message:
          '承認依頼前の施工体制が選択されていません。承認依頼は承認依頼前の施工体制を選択した状態で行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialog,
      },
      requestApprovalSuccess: {
        title: '選択した協力会社の承認依頼',
        message: '選択した協力会社の承認依頼が完了しました。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
      requestApprovalFailure: {
        title: '承認依頼に失敗しました',
        message:
          '選択した協力会社の承認依頼に失敗しました。再度、承認依頼操作を行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
      confirmCancelApproval: {
        title: messageUtility.getMessage('I-001-425'),
        message: '選択中の協力会社の承認依頼を取り消します。よろしいですか？',
        confirmButtonText: '承認依頼取り消しする',
        cancelButtonText: messageUtility.getMessage('I-000-008'),
        isNegative: true,
        onConfirm: () => {
          this.handleCloseDialog();
          this.submitCancelApproval();
        },
        onCancel: this.handleCloseDialog,
      },
      cancelApprovalEmpty: {
        title: messageUtility.getMessage('I-001-425'),
        message:
          '元請承認待の施工体制が選択されていません。承認依頼の取り消しは元請承認待の施工体制を選択した状態で行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialog,
      },
      cancelApprovalSuccess: {
        title: messageUtility.getMessage('I-001-425'),
        message: '選択した協力会社の承認依頼取り消しが完了しました。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
      cancelApprovalFailure: {
        title: '承認依頼取り消しに失敗しました',
        message:
          '選択した協力会社の承認依頼取り消しに失敗しました。再度、承認依頼取り消し操作を行ってください。',
        buttonText: messageUtility.getMessage('I-000-017'),
        onClose: this.handleCloseDialogAndRefreshPage,
      },
    };
    this.isSubmitingFlag = false;
    this.isPrimePartnerCompanyHasNodeInvited = false;
    this.masterSlideLoaderCallback = null;
    this.searchButtonRef = React.createRef(); // 検索ボタン要素

    /*
     *ページのリフレッシュ
     */
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_REFRESH, () => {
      this.onLoad();
    });

    /**
     * 絞り込みイベント
     */
    EventMg.registerEvent(PAGE_EVENT.SEARCH_PARAM);
    EventMg.addEventListener(
      PAGE_EVENT.SEARCH_PARAM,
      this.handleChangeSearchParam
    );

    /**
     * 絞り込み(保存用)イベント
     */
    EventMg.registerEvent(PAGE_EVENT.TEMP_SEARCH_PARAM);
    EventMg.addEventListener(
      PAGE_EVENT.TEMP_SEARCH_PARAM,
      this.handleChangeTempSearchParam
    );

    /**
     * ページネーション（次へ）
     */
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_PAGINATION_UP, () => {
      if (this.isPageLoading) {
        return;
      }
      this.isPageLoading = true;
      if (this.state.page >= this.state.lastPage) {
        return;
      }
      this.setState({ page: this.state.page + 1 });
      setTimeout(() => {
        let offset = (this.state.page - 1) * this.state.params.limit;
        urlParamManager.setPageNumber(
          'FieldTree',
          this.props.vw,
          this.state.page
        );
        EventMg.trigger(PAGE_EVENT.SEARCH_PARAM, 'offset', offset, true);
      }, 1);
    });

    /**
     * ページネーション前へ
     * */
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_PAGINATION_DOWN, () => {
      if (this.isPageLoading) {
        return;
      }
      this.isPageLoading = true;
      if (this.state.page <= 1) {
        return;
      }
      this.setState({ page: this.state.page - 1 });
      setTimeout(() => {
        let offset = (this.state.page - 1) * this.state.params.limit;
        urlParamManager.setPageNumber(
          'FieldTree',
          this.props.vw,
          this.state.page
        );
        EventMg.trigger(PAGE_EVENT.SEARCH_PARAM, 'offset', offset, true);
      }, 1);
    });
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.SHOW_EXIT_CONFIRM_DIALOG,
      callback => {
        this.masterSlideLoaderCallback = callback;
        this.setDialog('confirmExitFieldTree', DIALOG_TYPE_CONFIRM);
      }
    );
  }

  async componentDidMount() {
    //現場情報
    EventMg.addEventListener(FIELD_TREE_EVENTS.TREE_FIELD, data => {
      this.setState({ field_data: data.entities.field });
    });

    EventMg.addEventListener(FIELD_TREE_EVENTS.TOGGLE_CCUS_STATES, () => {
      SessionStorageService.setHashItem(
        'is_ccus_status_on',
        this.state.field_id,
        this.state.isCcusStateActiveFlg
          ? CCUS_STATUS_DISPLAY_TOGGLE.off.id
          : CCUS_STATUS_DISPLAY_TOGGLE.on.id
      );
      this.layout.forceUpdate();
      this.setState(prevState => ({
        isCcusStateActiveFlg: !prevState.isCcusStateActiveFlg,
      }));
    });

    this.setCcusSwitchState();
    await this.getLoginUserProfile();
    this.scrollMount();
    this.onLoadParam();
    this.FieldData();
    this.getCcusFieldTreeStatus();
    this.checkUserMainJv();
    // 検索条件がstateに反映されてから施工体制を取得するためにsetTimeout
    setTimeout(() => {
      this.onLoad();
    }, 1);

    EventMg.addEventListener(FIELD_TREE_EVENTS.SELECT_NODE, (id, statusKey) => {
      const selectedNodes = this.toggleNodeStatus(id, statusKey);
      this.setState({ selectedNodes }, () => {
        const isCheckedAll = this.calcSelectedAll(statusKey);
        this.setState({
          isCheckedAll: {
            ...this.state.isCheckedAll,
            [statusKey]: isCheckedAll,
          },
        });
      });
    });
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.COMPANY_DELETE_SUCCESS,
      this.handleDeleteNodeSuccess
    );
    EventMg.addEventListener(
      FIELD_TREE_EVENTS.COMPANY_DONE_SUCCESS,
      this.handleDeleteNodeSuccess
    );
  }

  componentWillUnmount() {
    EventMg.deleteEvent(PAGE_EVENT.SEARCH_PARAM);
    EventMg.deleteEvent(PAGE_EVENT.TEMP_SEARCH_PARAM);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_REFRESH);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_PAGINATION_UP);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_PAGINATION_DOWN);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TREE_FIELD);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.COMPANY_EDIT);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.COMPANY_WORKER_ASSIGNATION);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.TOGGLE_CCUS_STATES);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.SELECT_NODE);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.SHOW_EXIT_CONFIRM_DIALOG);
    EventMg.deleteEvent(FIELD_TREE_EVENTS.COMPANY_DELETE_SUCCESS);
    SessionStorageService.removeFieldTreeHasNodeInvited();
  }

  // 検索条件セット
  handleChangeSearchParam = (name, value, keepPage) => {
    //全部のパラメータを作成
    let params = _.cloneDeep(this.state.params);
    params[name] = value;
    if (name === 'jv_company_branch_id') {
      let tempParams = _.cloneDeep(this.state.tempParams);

      params.jobs = [];
      tempParams.jobs = [];
      params.user_ids = [];
      params.user_names = [];
      tempParams.user_ids = [];
      tempParams.user_names = [];

      this.setState({
        params,
        tempParams: tempParams,
        refreshFlag: true,
      });
    } else if (name === 'approval_flag') {
      let tempParams = _.cloneDeep(this.state.tempParams);
      tempParams[name] = value;
      this.setState({
        params,
        tempParams,
        refreshFlag: false,
      });
    } else {
      this.setState({
        params,
        refreshFlag: false,
      });
    }

    // 検索条件を変えた場合ページを1に戻す BLDE_V2-16388
    if (keepPage === true) {
      this.onLoad();
    } else {
      //表示更新
      this.setState({ page: 1 });
      setTimeout(() => {
        urlParamManager.setPageNumber(
          'FieldTree',
          this.props.vw,
          this.state.page
        );
        this.handleChangeSearchParam('offset', 0, true);
      }, 1);
    }
  };

  // 検索ボタンで検索条件セット
  handleSetSearchParam = () => {
    this.searchButtonRef.current.disabled = true;
    let params = _.cloneDeep(this.state.tempParams);
    params['offset'] = 0;
    params['jv_company_branch_id'] = this.state.params['jv_company_branch_id'];

    this.setState(
      {
        params,
        refreshFlag: false,
        page: 1,
      },
      () => {
        this.onLoad();
      },
    );
  };

  // 検索条件(保存用)セット
  handleChangeTempSearchParam = (name, value, valueNames) => {
    //全部のパラメータを作成
    let tempParams = _.cloneDeep(this.state.tempParams);
    tempParams[name] = value;
    switch (name) {
      case 'company_branch_ids':
        tempParams.company_branch_names = valueNames;
        break;
      case 'user_ids':
        tempParams.user_names = valueNames;
        break;
      case 'all_box_finished':
        if (value && !tempParams.show_finished_box) {
          // if checked all_box_finished -> auto checked show_finished_box
          tempParams.show_finished_box = true;
        }
        break;
      case 'show_finished_box':
        if (!value && tempParams.all_box_finished) {
          // if unchecked show_finished_box -> auto unchecked all_box_finished
          tempParams.all_box_finished = false;
        }
        break;
      default:
        break;
    }
    this.setState({ tempParams });
  };

  //該当ページをロードする設定
  onLoadParam() {
    const fieldTreeSearchParams = SessionStorageService.getFieldTreeSearchParam();
    const searchParams = fieldTreeSearchParams[this.state.field_id];
    if (searchParams !== undefined && searchParams !== null) {
      const page = searchParams.page;
      const params = searchParams.param;
      this.setState({
        page,
        params,
        tempParams: _.cloneDeep(params),
      });
    }
  }

  /**
   * 検索条件を保存する
   * */
  saveParam = () => {
    SessionStorageService.setFieldTreeSearchParam(
      this.state.field_id,
      this.state.params,
      this.state.page
    );
  };

  scrollMount() {
    var _naviDelegate = new navigationDelegate();
    _naviDelegate.init();
    var _heightDelegate = new heightDelegate();
    _heightDelegate.initEvent(['#tree_accordion_btn']);

    setTimeout(() => {
      //スクロール高さを固定
      this.layout = new LayoutManager();
      this.layout.init();
      this.layout.setNavigationDelegate(_naviDelegate);
      this.layout.setHeightDelegate(_heightDelegate);
      this.layout.setHeightUpdateElement(`.fieldstree-main__tree`);
      _naviDelegate.forceUpdate();
      _heightDelegate.forceUpdate();
      this.layout.forceUpdate();

      const tree = document.querySelector('.fieldstree-main__tree');
      // ロード前に遷移したらたまにnullエラーになるのでチェックしてスクロールON
      // 本当はdocument.querySelectorやめてほしい
      if (tree !== null) {
        tree.style.overflow = 'auto';
      }
    }, 500);
  }

  /**
   * 絞り込みリセット
   */
  resetParam() {
    const params = _.cloneDeep(this.paramsDefault);

    // BLDE_V2-41481: 選択中のJV情報はリセットしない
    params['jv_company_branch_id'] = this.state.params['jv_company_branch_id'];

    this.PageNumber = 0;
    this.setState({
      params,
      tempParams: _.cloneDeep(params),
      page: 1,
      refreshFlag: true,
    });
    urlParamManager.setPageNumber('FieldTree', this.props.vw, 1);
    setTimeout(() => {
      this.onLoad();
    }, 1);

    this.searchFormRef = this.refs.searchForm;
    _.each(
      this.searchFormRef.querySelectorAll('input[name=approval_flag]'),
      radio => {
        radio.checked = false;
      }
    );
    this.DDPartnerCompany.resetValue();
    this.DDForeman.resetValue();
    EventMg.trigger(FIELD_TREE_EVENTS.TREE_CLEAR_SEARCH_PARAM);
  }

  resetRefreshFlag() {
    this.setState({ refreshFlag: false });
  }

  /**
   * CSVダウンロードダイアログ
   */
  CSVExportDialog() {
    dialogLoader.show(dialog.CSVExportPartnerCompany, {
      state: {
        // BLDE_V2-41525: ローカルストレージの値は別タブで別現場選択時に変わる。画面表示時に取得したstateを使用。
        fieldId: this.state.field_id,
      },

      callback: {
        csvDownloadPreparation: (csvType, companyBranchIds) => {
          let params, apiPath;

          if (csvType === CSV_TYPE.USER_LIST) {
            params = {
              role_codes: [USER_ROLES.partner.id, USER_ROLES.foreman.id],
            };
            apiPath = `api/private/fields/${this.state.field_id}/user_lists.csv`;
            csvDownloader(apiPath, params);
          } else {
            params =
              _.size(companyBranchIds) > 0
                ? { company_branch_ids: companyBranchIds }
                : {};
            apiPath = `api/private/fields/${this.state.field_id}/field_trees/tree_company_partners.csv`;
            csvDownloader(apiPath, params, 'POST');
          }
        },
        close: () => {
          dialogLoader.close();
        },
      },
    });
  }

  /**
   * 連携状態の表示の切り替え
   */
  setCcusSwitchState = () => {
    const sessionCcusState = SessionStorageService.getHashItem(
      'is_ccus_status_on',
      this.state.field_id,
      this.state.isCcusStateActiveFlg
    );
    if (!_.isNil(sessionCcusState)) {
      const isCcusStateActiveFlg =
        sessionCcusState === CCUS_STATUS_DISPLAY_TOGGLE.on.id;
      this.setState({ isCcusStateActiveFlg });
    }
  };

  /**
   * https://v2-dev.buildee.jp/apidocs/public/user_profiles/index.html
   * /api/private/user_profiles
   */
  async getLoginUserProfile() {
    const data = await api.UserProfile();
    if (data) {
      this.setState({
        user_profile: data.entities.user_profile,
        role_code: data.entities.role_code,
      });
    }
  }

  getListNodeNotApproved = (data, pendingIds = [], invitedIds = []) => {
    _.forEach(data, node => {
      const approvalFlag = Number(node.approval_flag);
      const hasPermission =
        isLoginUserPrimaryCompany() ||
        (isLoginUserPartnerCompany() &&
          _.get(node, 'permissions.partner_box_detail.request_approval'));
      if (isApiFlagOff(node.finish_flag) && hasPermission) {
        if (approvalFlag === APPROVAL_STATUS_FIELDTREE.invited.id) {
          invitedIds.push(node.id);
        } else if (approvalFlag === APPROVAL_STATUS_FIELDTREE.pending.id) {
          pendingIds.push(node.id);
        }
      }
      if (!_.isEmpty(node.children)) {
        this.getListNodeNotApproved(node.children, pendingIds, invitedIds);
      }
    });
    return {
      pending: pendingIds,
      invited: invitedIds,
    };
  };

  // メイン元請のユーザーチェック
  checkUserMainJv = () => {
    const params = { offset: 0, limit: 2 };
    return api.jvCompanyList(this.state.field_id, params).then(response => {
      if (response.result) {
        const jvList = _.get(response, 'data.entities.company');
        const mainJv = jvList[0];
        const mainJvCompanyId = _.toString(mainJv.company_id);
        const isUserMainJV = this.state.companyId === mainJvCompanyId;
        this.setState({ isUserMainJV, jvFlag: _.size(jvList) > 1 });
      }
    });
  };

  /**
   * 施工体系図のAPI呼び出し
   *
   * @memberof FieldTreePage
   */
  async onLoad() {
    /* NOTE
     * stateの中身が変わらない場合、配下のコンポーネントで正常に動かないことがあるため
     * treeを一度全て削除する
     * */
    this.setState({ field_trees: [] });
    this.forceUpdate();

    const params = {};
    const stateParams = this.state.params;
    if (!_.isNull(stateParams.approval_flag)) {
      params.approval_flag = stateParams.approval_flag;
    }
    params.user_ids = stateParams.user_ids;
    params.job_ids = _.map(stateParams.jobs, 'id');
    params.company_branch_ids = stateParams.company_branch_ids;
    if (!_.isNull(stateParams.joining_flag)) {
      params.joining_flag = stateParams.joining_flag;
    }
    if (!_.isNull(stateParams.has_foreman)) {
      params.has_foreman = stateParams.has_foreman;
    }
    if (!_.isNull(stateParams.has_partner)) {
      params.has_partner = stateParams.has_partner;
    }
    if (!_.isNull(stateParams.only_ccus_error)) {
      params.only_ccus_error = stateParams.only_ccus_error;
    }
    if (!_.isNull(stateParams.jv_company_branch_id)) {
      params.jv_company_branch_id = stateParams.jv_company_branch_id;
    }
    params.partner_box_group_status = {
      all_box_continue: this.toApiFlagValue(stateParams.all_box_continue),
      continue_and_finished: this.toApiFlagValue(
        stateParams.continue_and_finished
      ),
      all_box_finished: this.toApiFlagValue(stateParams.all_box_finished),
    };
    params.show_finished_box = this.toApiFlagValue(
      stateParams.show_finished_box
    );

    params.offset = stateParams.offset;
    params.limit = stateParams.limit;

    const fieldTreeId = SessionStorageService.getFieldTreeId();
    if (!_.isNull(fieldTreeId)) {
      params.field_tree_id = fieldTreeId;
    }

    this.saveParam();
    const data = await api.FieldTreeList(this.state.field_id, params);
    if (this.searchButtonRef.current) {
      this.searchButtonRef.current.disabled = false;
    }
    if (data) {
      // 元請け?
      const contractor = data.entities.prime_contractor_company_branch;
      const partnerCompanyCanRequest = data.entities.request_approval_all_flag;
      let _field_trees = [
        {
          company_name: contractor.company_branch_name,
          id: 0,
        },
      ];

      // BLDE_V2-41481: 選択中JVの初期設定
      const clone_params = _.cloneDeep(this.state.params);
      clone_params['jv_company_branch_id'] = contractor.id;

      _field_trees.push(...data.entities.field_trees);
      let constructor_company = _field_trees.shift();
      _field_trees = _.sortBy(_field_trees, 'private_partner_company_flag');
      _field_trees.unshift(constructor_company);
      const listNodeNotApprove = this.getListNodeNotApproved(_field_trees);
      //ここで元請け設定
      let constructor = _.cloneDeep(contractor);
      constructor.constructor = true;

      // ページ数取得
      const lastPage = data.entities.page_count;
      if (isLoginUserPartnerCompany()) {
        const enterWorkerFieldTreeId = getQueryStringParameter(
          ENTER_WORKER_FIELD_TREE_ID_PARAM_NAME
        );
        if (!enterWorkerFieldTreeId) {
          this.isPrimePartnerCompanyHasNodeInvited =
            data.entities.has_field_tree_invited;
          SessionStorageService.setFieldTreeHasNodeInvited(
            this.isPrimePartnerCompanyHasNodeInvited
          );
        }
      }
      this.setState(
        {
          field_trees: _field_trees,
          constructor,
          params: clone_params,
          login_user_contractor: contractor.login_user_contractor,
          results: {
            results: data.results,
            total: data.total,
          },
          isLoading: false,
          partnerCompanyCanRequest,
          lastPage,
          fieldTreeStatus: {
            approvalStatus: data.entities.approval_status,
            hasPartnerCompanyPending: data.entities.approval_pending_flag,
            hasPartnerCompanyInvited: data.entities.disapproval_flag,
          },
          listNodeNotApprove,
        },
        () => {
          if (this.layout) {
            this.layout.forceUpdate();
          }
          const isCheckAllStatusPending = this.calcSelectedAll(pendingKey);
          const isCheckAllStatusInvited = this.calcSelectedAll(invitedKey);
          this.setState({
            isCheckedAll: {
              [pendingKey]: isCheckAllStatusPending,
              [invitedKey]: isCheckAllStatusInvited,
            },
          });
        }
      );
      EventMg.trigger(FIELD_TREE_EVENTS.TREE_LOADED, _.cloneDeep(data));
      this.isPageLoading = false;
    }
  }

  /**
   * convert boolean value to flag value for API calling parameters
   * @param {boolean} value value of param need to convert
   * @return {number} 1: truthy value; 0: falsy value
   */
  toApiFlagValue = value => {
    return value ? API_FLAG.On : API_FLAG.Off;
  };

  async FieldData() {
    const field = await api.FieldData(this.state.field_id);
    if (field) {
      EventMg.trigger(FIELD_TREE_EVENTS.TREE_FIELD, field);
    }
  }

  /**
   * ユーザーはccus連携を行う権限を確認
   */
  canAccessCcus = () => {
    // FieldDataの処理がまだ終わっていない場合など
    if (_.isNil(this.state.field_data.company)) {
      return false;
    }
    // メイン元請のユーザーの場合、OK
    return this.state.isUserMainJV;
  };

  /**
   * ccus施工体制連携状態を取得する
   */
  getCcusFieldTreeStatus = async () => {
    let autoTaskActive = null;
    let fieldConnectionStatus = null;
    let ccusErrorDialogFlg = false;
    let ccusErrorMessage = '';
    let isBeforeCcusConnectionFlg = true;
    let isCcusProcessingFlg = false;

    try {
      const res = await api.fetchCcusFieldTreeState(this.state.field_id);
      if (res) {
        if (res.result) {
          if (!_.isNil(res.data.ccus_field_tree_auto_task)) {
            fieldConnectionStatus =
              res.data.ccus_field_tree_auto_task.connection_status;
            autoTaskActive = res.data.ccus_field_tree_auto_task.active;
            isBeforeCcusConnectionFlg = false;
            isCcusProcessingFlg =
              res.data.execution_status === EXECUTION_STATUS.executing;
            if (
              res.data.entities.ccus_field_tree_state_managements.length === 0
            ) {
              // 施工体制のCCUS連携情報がない場合、CCUS施工体制連携ブロック非表示
              if (this.state.role_code === USER_ROLES.partner.id) {
                autoTaskActive = null;
              }
            }
          }
        } else {
          ccusErrorDialogFlg = true;
          if (res.message) {
            ccusErrorMessage = res.message;
          } else {
            ccusErrorMessage = res.data.message;
          }
        }
      }
    } catch (error) {
      ccusErrorDialogFlg = true;
      if (error.message) {
        ccusErrorMessage = error.message;
      } else {
        ccusErrorMessage = error.data.message;
      }
    }
    // stateを設定する
    this.setState({
      fieldConnectionStatus,
      autoTaskActive,
      isBeforeCcusConnectionFlg,
      isCcusProcessingFlg,
      ccusErrorDialogFlg,
      ccusErrorMessage,
    });
  };

  /**
   * 施工体制をCCUSに連携する
   */
  ccusFieldTree = async () => {
    let ccusErrorDialogFlg = false;
    let displayCcusDialogFlg = false;
    let ccusErrorMessage = '';
    let isCcusProcessingFlg = false;
    let isBeforeCcusConnectionFlg;
    let ccusApiLoadingFlg = this.state.ccusApiLoadingFlg;

    if (ccusApiLoadingFlg || this.state.constructor.main_jv_ccus_seceded_flag) {
      return;
    }
    this.setState({ ccusApiLoadingFlg: true });

    try {
      const res = await api.ccusFieldTree(this.state.field_id);
      if (res) {
        if (!res.result) {
          [ccusErrorDialogFlg, ccusErrorMessage] = this.ccusErrorHandler(res);
        } else {
          displayCcusDialogFlg = true;
          isCcusProcessingFlg = true;
          isBeforeCcusConnectionFlg = false;
        }
      }
    } catch (error) {
      [ccusErrorDialogFlg, ccusErrorMessage] = this.ccusErrorHandler(error);
    }

    ccusApiLoadingFlg = false;

    this.setState(prevState => {
      if (_.isNil(isBeforeCcusConnectionFlg)) {
        isBeforeCcusConnectionFlg = prevState.isBeforeCcusConnectionFlg;
      }

      return {
        ccusErrorDialogFlg,
        displayCcusDialogFlg,
        ccusErrorMessage,
        isCcusProcessingFlg,
        isBeforeCcusConnectionFlg,
        ccusApiLoadingFlg,
      };
    });
  };

  /**
   * エラーメッセージ取得
   */
  ccusErrorHandler = object => {
    const ccusErrorDialogFlg = true;
    let ccusErrorMessage = '';
    if (object.message) {
      ccusErrorMessage = object.message;
    } else {
      ccusErrorMessage = object.data.message;
    }
    return [ccusErrorDialogFlg, ccusErrorMessage];
  };

  /**
   * CCUSエラーダイアログを閉じる
   */
  closeCcusErrorDialog = () => {
    let state = _.cloneDeep(this.state);
    state.ccusErrorDialogFlg = false;
    state.ccusErrorMessage = '';
    this.setState(state);
  };

  //承認
  async approve() {
    let selectedNodes = _.cloneDeep(this.state.selectedNodes);
    selectedNodes = [
      ...selectedNodes[pendingKey],
      ...selectedNodes[invitedKey],
    ];
    selectedNodes = _.map(selectedNodes, id => ({
      id,
      approval_flag: APPROVAL_STATUS_FIELDTREE.approval.id,
    }));
    const param = { field_trees: selectedNodes };
    const response = await api.updateFieldTreeList(this.state.field_id, param);
    if (response.result) {
      return this.resetSelectedNodes(() => {
        this.setDialog('infoApproveSuccess', DIALOG_TYPE_INFO);
      });
    }
    this.setDialog('infoApproveFailure', DIALOG_TYPE_INFO);
  }

  //絞り込み検索の開閉
  toggleSearchForm() {
    this.layout.forceUpdate();
    this.setState({ showForm: !this.state.showForm });
  }

  renderSelectSearchValue = (name, value, label) => {
    return (
      <div className='element__item'>
        <label className='radio'>
          <input
            type='radio'
            name={name}
            value={value}
            checked={this.state.tempParams[name] === value}
            onChange={() =>
              EventMg.trigger(PAGE_EVENT.TEMP_SEARCH_PARAM, name, value)
            }
          />
          <i className='i-2x' />
          <span>{label}</span>
        </label>
      </div>
    );
  };

  /**
   * render to DOM a single check box with label
   * @param {string} name the param name that used for check box's value
   * @param {string} label label detail for check box
   * @return {JSX.Element}
   */
  renderSingleCheckBoxSearchValue = (name, label) => {
    return (
      <div className='element__item'>
        <label className='checkbox'>
          <input
            type='checkbox'
            id={`checkbox_${name}`}
            checked={this.state.tempParams[name]}
            onChange={e => this.handleChangeTempSearchParam(name, e.target.checked)}
          />
          <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
          <span>{label}</span>
        </label>
      </div>
    );
  };

  isFieldCompleted = () => {
    return moment(
      this.state.field_data.complete_schedule_date,
      'YYYY/MM/DD'
    ).isBefore(moment(), 'day');
  };

  handleToggleCcusStatus = () => {
    EventMg.trigger(FIELD_TREE_EVENTS.TOGGLE_CCUS_STATES);
  };

  /**
   * CCUS施工体制連携ブロックのテキスト表示
   */
  getCcusBlockMessage = () => {
    const {
      role_code,
      isCcusProcessingFlg,
      autoTaskActive,
      constructor,
      jvFlag,
    } = this.state;
    if (constructor.main_jv_ccus_seceded_flag) {
      return messageUtility.getMessage(jvFlag ? 'I-000-238' : 'I-000-246');
    }
    // 連携中
    if (isCcusProcessingFlg) {
      return messageUtility.getMessage('I-000-225');
    }
    // 竣工後
    if (this.isFieldCompleted()) {
      return this.canAccessCcus()
        ? messageUtility.getMessage('I-000-227')
        : messageUtility.getMessage('I-000-226');
    }
    // 権限なし
    if (!this.canAccessCcus()) {
      // 協力会社管理者の場合
      if (isPartnerRoleId(role_code)) {
        // 自動連係ONの場合
        if (autoTaskActive) {
          return messageUtility.getMessage('I-000-228');
        }
        // 自動連係OFFの場合
        return messageUtility.getMessage('I-000-229');
      }
      // sub jv
      if (isPrimaryCompanyRoleId(role_code)) {
        // 自動連係ONの場合
        if (autoTaskActive) {
          return messageUtility.getMessage('I-000-228');
        }
        // 自動連係OFFの場合
        return messageUtility.getMessage('I-000-230');
      }
      return '';
    }
    // 権限あり
    // 自動連係ONの場合
    if (autoTaskActive) {
      return messageUtility.getMessage('I-000-231');
    }
    // 自動連係OFFの場合
    return messageUtility.getMessage('I-000-232');
  };

  setDialog = (key, dialogType = DIALOG_TYPE_CONFIRM) => {
    let configDialog = {};
    if (isLoginUserPrimaryCompany()) {
      configDialog = this.configDialogPrimeCompany;
    } else if (isLoginUserPartnerCompany()) {
      configDialog = this.configDialogPartnerCompany;
    }
    this.setState({
      isShowDialog: {
        ...this.state.isShowDialog,
        [dialogType]: true,
      },
      dialogState: configDialog[key],
    });
  };

  handleCloseDialog = callback => {
    this.setState(
      {
        isShowDialog: {
          info: false,
          confirm: false,
        },
        dialogState: {},
      },
      () => {
        if (_.isFunction(callback)) {
          callback();
        }
      }
    );
  };

  handleCloseDialogAndRefreshPage = () => {
    this.handleCloseDialog(this.refreshPage);
  };

  renderDescription = () => {
    let content = null;
    const { fieldTreeStatus } = this.state;
    const { approvalStatus, hasPartnerCompanyPending } = fieldTreeStatus;
    if (isLoginUserPartnerCompany()) {
      let title = null;
      let arrayContent = [];
      if (
        [
          APPROVAL_DESCRIPTION_STATUS.PRIMARY_PARTNER_COMPANY,
          APPROVAL_DESCRIPTION_STATUS.SECONDARY_PARTNER_COMPANY,
        ].includes(approvalStatus)
      ) {
        switch (approvalStatus) {
          case APPROVAL_DESCRIPTION_STATUS.PRIMARY_PARTNER_COMPANY: {
            title =
              '元請会社による現場体制の承認が必要な会社があります。承認されていない会社のユーザーは現場にアクセスできません。';
            arrayContent = [
              '承認依頼前：承認依頼を行ってください。',
              '元請承認待：元請会社による承認操作をお待ちください。',
            ];
            break;
          }
          case APPROVAL_DESCRIPTION_STATUS.SECONDARY_PARTNER_COMPANY: {
            title =
              '元請会社による現場体制の承認が必要な会社があります。承認されていない会社のユーザーは現場にアクセスできません。';
            arrayContent = [
              '承認依頼前：一次協力会社による承認依頼操作をお待ちください。数日経過しても承認依頼操作が行われていない場合は、一次協力会社の管理者に直接対応を依頼してください。',
              '元請承認待：元請会社による承認操作をお待ちください。',
            ];
            break;
          }
        }
        content = (
          <React.Fragment>
            {title}
            <ul className='Description__content--list'>
              {arrayContent.map((text, index) => (
                <li key={index} className='Description__content--list-item'>
                  {text}
                </li>
              ))}
            </ul>
          </React.Fragment>
        );
      }
    }
    if (isLoginUserPrimaryCompany() && hasPartnerCompanyPending) {
      content =
        '現場体制の承認が必要な会社があります。承認されていない会社のユーザーは現場にアクセスできません。';
    }
    return (
      content && (
        <div className='fieldstree-main__attention'>
          <Description type='primary'>{content}</Description>
        </div>
      )
    );
  };

  handleCheckAllNode = (e, key) => {
    const { selectedNodes, isCheckedAll, listNodeNotApprove } = this.state;
    let nodeIds = _.clone(selectedNodes[key]);

    if (e.target.checked) {
      nodeIds = _.union(nodeIds, listNodeNotApprove[key]);
    } else {
      _.pullAll(nodeIds, listNodeNotApprove[key]);
    }

    this.setState({
      selectedNodes: {
        ...selectedNodes,
        [key]: nodeIds,
      },
      isCheckedAll: {
        ...isCheckedAll,
        [key]: e.target.checked,
      },
    });
  };

  renderListActionPrimeContractor = () => {
    const {
      fieldTreeStatus: { hasPartnerCompanyPending, hasPartnerCompanyInvited },
    } = this.state;
    return (
      <React.Fragment>
        <li className='btn-menu__item'>
          <button
            className={
              hasPartnerCompanyPending || hasPartnerCompanyInvited
                ? 'btn--effective'
                : 'btn--disabled'
            }
            onClick={this.handleApproval}
            disabled={!(hasPartnerCompanyPending || hasPartnerCompanyInvited)}
          >
            選択した会社を承認
          </button>
        </li>
        <li className='btn-menu__item'>
          <button
            className={
              hasPartnerCompanyPending ? 'btn--negative' : 'btn--disabled'
            }
            onClick={this.handleRejectApproval}
            disabled={!hasPartnerCompanyPending}
          >
            選択した会社を否認
          </button>
        </li>
      </React.Fragment>
    );
  };

  renderListActionPartnerCompany = () => {
    const {
      fieldTreeStatus: { hasPartnerCompanyPending, hasPartnerCompanyInvited },
    } = this.state;
    return (
      <React.Fragment>
        <li className='btn-menu__item'>
          <button
            className={
              hasPartnerCompanyInvited ? 'btn--effective' : 'btn--disabled'
            }
            onClick={this.handleRequestApproval}
            disabled={!hasPartnerCompanyInvited}
          >
            選択した会社の承認依頼
          </button>
        </li>
        <li className='btn-menu__item'>
          <button
            className={
              hasPartnerCompanyPending ? 'btn--negative' : 'btn--disabled'
            }
            onClick={this.handleCancelApproval}
            disabled={!hasPartnerCompanyPending}
          >
            選択した会社の承認依頼取り消し
          </button>
        </li>
      </React.Fragment>
    );
  };

  getClassNameCheckboxText = key => {
    const { listNodeNotApprove } = this.state;
    return _.isEmpty(listNodeNotApprove[key]) ? 'checkbox-disabled' : '';
  };

  renderListCheckboxPrimeContractor = () => {
    const { isCheckedAll, listNodeNotApprove } = this.state;
    return (
      <div className='element__item'>
        <label className='checkbox'>
          <input
            type='checkbox'
            checked={isCheckedAll[pendingKey]}
            onChange={e => this.handleCheckAllNode(e, pendingKey)}
            disabled={_.isEmpty(listNodeNotApprove[pendingKey])}
          />
          <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
          <span className={this.getClassNameCheckboxText(pendingKey)}>
            元請承認待を一括選択
          </span>
        </label>
      </div>
    );
  };

  renderListCheckboxPartnerCompany = () => {
    if (!this.state.partnerCompanyCanRequest) {
      return null;
    }
    const { isCheckedAll, listNodeNotApprove } = this.state;
    return (
      <React.Fragment>
        <div className='element__item'>
          <label className='checkbox'>
            <input
              type='checkbox'
              checked={isCheckedAll[invitedKey]}
              onChange={e => this.handleCheckAllNode(e, invitedKey)}
              disabled={_.isEmpty(listNodeNotApprove[invitedKey])}
            />
            <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
            <span className={this.getClassNameCheckboxText(invitedKey)}>
              承認依頼前一括選択
            </span>
          </label>
        </div>
        <div className='element__item'>
          <label className='checkbox'>
            <input
              type='checkbox'
              checked={isCheckedAll[pendingKey]}
              onChange={e => this.handleCheckAllNode(e, pendingKey)}
              disabled={_.isEmpty(listNodeNotApprove[pendingKey])}
            />
            <i className='i-square-checkbox i-2_5x' aria-hidden='true' />
            <span className={this.getClassNameCheckboxText(pendingKey)}>
              元請承認待一括選択
            </span>
          </label>
        </div>
      </React.Fragment>
    );
  };

  renderListCheckBox = () => {
    if (!isLoginUserPrimaryCompany() && !this.state.partnerCompanyCanRequest) {
      return null;
    }
    return (
      <div className='fieldstree-main__menu list-checkbox-all'>
        {isLoginUserPrimaryCompany()
          ? this.renderListCheckboxPrimeContractor()
          : this.renderListCheckboxPartnerCompany()}
      </div>
    );
  };

  toggleNodeStatus = (id, statusKey) => {
    const selectedNodes = _.cloneDeep(this.state.selectedNodes);
    const isSelectedNode = _.includes(selectedNodes[statusKey], id);
    if (isSelectedNode) {
      _.remove(selectedNodes[statusKey], nodeId => id === nodeId);
    } else {
      selectedNodes[statusKey].push(id);
    }
    return selectedNodes;
  };

  calcSelectedAll = statusKey => {
    const { selectedNodes, listNodeNotApprove } = this.state;
    if (_.isEmpty(listNodeNotApprove[statusKey])) {
      return false;
    }
    let isCheckedAll = true;
    _.forEach(listNodeNotApprove[statusKey], id => {
      if (!_.includes(selectedNodes[statusKey], id)) {
        isCheckedAll = false;
        return false;
      }
    });
    return isCheckedAll;
  };

  refreshPage = () => {
    EventMg.trigger(FIELD_TREE_EVENTS.TREE_REFRESH);
  };

  handleApproval = () => {
    const { selectedNodes } = this.state;
    const isEmptyNodeForApprove =
      _.isEmpty(selectedNodes[pendingKey]) &&
      _.isEmpty(selectedNodes[invitedKey]);
    if (isEmptyNodeForApprove) {
      this.setDialog('infoNotSelectNodeForApprove', DIALOG_TYPE_INFO);
    } else {
      this.setDialog('confirmApproval', DIALOG_TYPE_CONFIRM);
    }
  };

  handleRejectApproval = () => {
    const { selectedNodes } = this.state;
    const isEmptyNodeForReject = _.isEmpty(selectedNodes[pendingKey]);
    if (isEmptyNodeForReject) {
      this.setDialog('infoNotSelectNodeForReject', DIALOG_TYPE_INFO);
    } else {
      this.setDialog('confirmReject', DIALOG_TYPE_CONFIRM);
    }
  };

  submitRejectApproval = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    let selectedNodes = _.cloneDeep(this.state.selectedNodes);
    selectedNodes = [...selectedNodes[pendingKey]];
    selectedNodes = _.map(selectedNodes, id => ({
      id,
      approval_flag: APPROVAL_STATUS_FIELDTREE.invited.id,
    }));
    const param = { field_trees: selectedNodes };
    const response = await api.updateFieldTreeList(this.state.field_id, param);
    this.isSubmitingFlag = false;
    if (response.result) {
      await this.resetSelectedNodes();
      await this.setDialog('infoRejectSuccess', DIALOG_TYPE_INFO);
      return;
    }
    this.setDialog('infoRejectFailure', DIALOG_TYPE_INFO);
  };

  handleRequestApproval = () => {
    if (_.isEmpty(this.state.selectedNodes[invitedKey])) {
      this.setDialog('requestApprovalEmpty', DIALOG_TYPE_INFO);
    } else {
      this.setDialog('confirmRequestApproval', DIALOG_TYPE_CONFIRM);
    }
  };

  handleCancelApproval = () => {
    if (_.isEmpty(this.state.selectedNodes[pendingKey])) {
      this.setDialog('cancelApprovalEmpty', DIALOG_TYPE_INFO);
    } else {
      this.setDialog('confirmCancelApproval', DIALOG_TYPE_CONFIRM);
    }
  };

  resetSelectedNodes = callback => {
    this.setState(
      {
        selectedNodes: {
          [pendingKey]: [],
          [invitedKey]: [],
        },
        isCheckedAll: {
          [pendingKey]: false,
          [invitedKey]: false,
        },
      },
      callback
    );
  };

  submitRequestApproval = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const { selectedNodes } = this.state;
    const invitedNodeIds = [...selectedNodes[invitedKey]];
    const invitedNodes = _.map(invitedNodeIds, id => ({
      id,
      approval_flag: APPROVAL_STATUS_FIELDTREE.pending.id,
    }));
    const param = { field_trees: invitedNodes };
    const response = await api.updateFieldTreeList(this.state.field_id, param);
    this.isSubmitingFlag = false;
    if (!response.result) {
      this.setDialog('requestApprovalFailure', DIALOG_TYPE_INFO);
      return;
    }
    await this.resetSelectedNodes();
    await this.setDialog('requestApprovalSuccess', DIALOG_TYPE_INFO);
  };

  submitCancelApproval = async () => {
    if (this.isSubmitingFlag) {
      return;
    }
    this.isSubmitingFlag = true;
    const { selectedNodes } = this.state;
    const pendingNodeIds = [...selectedNodes[pendingKey]];
    const pendingNodes = _.map(pendingNodeIds, id => ({
      id,
      approval_flag: APPROVAL_STATUS_FIELDTREE.invited.id,
    }));
    const param = { field_trees: pendingNodes };
    const response = await api.updateFieldTreeList(this.state.field_id, param);
    this.isSubmitingFlag = false;
    if (!response.result) {
      this.setDialog('cancelApprovalFailure', DIALOG_TYPE_INFO);
      return;
    }
    await this.resetSelectedNodes();
    await this.setDialog('cancelApprovalSuccess', DIALOG_TYPE_INFO);
  };

  onConfirmDialogExitFieldTree = () => {
    this.handleCloseDialog(() => {
      SessionStorageService.removeFieldTreeHasNodeInvited();
      if (_.isFunction(this.masterSlideLoaderCallback)) {
        this.masterSlideLoaderCallback();
      }
    });
  };

  handleDeleteNodeSuccess = fieldTree => {
    const { selectedNodes } = this.state;
    const deletedIds = this.getAllNodeIdsInNode(fieldTree);
    const selectedPendingIds = _.pullAll(
      _.clone(selectedNodes[pendingKey]),
      deletedIds
    );
    const selectedInvitedIds = _.pullAll(
      _.clone(selectedNodes[invitedKey]),
      deletedIds
    );
    this.setState(
      {
        selectedNodes: {
          [pendingKey]: selectedPendingIds,
          [invitedKey]: selectedInvitedIds,
        },
      },
      () => {
        const isCheckAllStatusPending = this.calcSelectedAll(pendingKey);
        const isCheckAllStatusInvited = this.calcSelectedAll(invitedKey);
        this.setState({
          isCheckedAll: {
            [pendingKey]: isCheckAllStatusPending,
            [invitedKey]: isCheckAllStatusInvited,
          },
        });
      }
    );
  };

  getAllNodeIdsInNode = (node, ids) => {
    if (!_.isArray(ids)) {
      ids = [];
    }
    ids.push(node.id);
    if (_.size(node.children) > 0) {
      _.forEach(node.children, child => {
        this.getAllNodeIdsInNode(child, ids);
      });
    }
    return ids;
  };

  isEmptySearchParams = () => {
    const omitKeys = ['offset', 'limit', 'jv_company_branch_id'];
    const searchParams = _.omit(this.state.params, omitKeys);
    const emptySearchParams = _.omit(this.paramsDefault, omitKeys);
    return _.isEqual(emptySearchParams, searchParams);
  };

  handleShowGuide = async () => {
    const { role_code } = this.state;
    const newTab = window.open('/LayoutPrint', '_blank');
    let isCloseTab = true;
    const fileCode = isPrimaryCompanyRoleId(role_code)
      ? PRESIGN_FILES.fieldTreeGuideForContractor
      : PRESIGN_FILES.fieldTreeGuideForPartner;
    try {
      const response = await StaticFileService.getPresignedUrlS3({
        file_code: fileCode,
      });
      newTab.location.href = _.get(
        response,
        'data.entities.pdf_urls.get_pdf_url'
      );
      isCloseTab = false;
    } finally {
      if (isCloseTab) {
        newTab.close();
      }
    }
  };

  resetSelectedPartnerCompanyBranch = () => {
    const params = _.cloneDeep(this.state.params);
    const tempParams = _.cloneDeep(this.state.tempParams);
    params['company_branch_ids'] = [];
    params['company_branch_names'] = [];
    tempParams['company_branch_ids'] = [];
    tempParams['company_branch_names'] = [];

    this.setState({
      params,
      tempParams,
    });
  };

  render() {
    const SearchFormHeader = ({ total }) => (
      <div className='fieldstree-main__searchform__header'>
        <div>
          表示<span className='bold'>{total || 0}</span>件
          <button
            className='btn-text--mini'
            onClick={() => {
              this.resetParam();
            }}
          >
            条件クリア
          </button>
        </div>
        <div className='header-pagination'>
          <FieldTreePagination
            page={this.state.page}
            lastPage={this.state.lastPage}
          />
        </div>
      </div>
    );

    const constructorBtnShow = () => {
      return isLoginUserPrimaryCompany()
        ? { display: 'flex' }
        : { display: 'none' };
    };

    /**
     * "職長の初期パスワードを再発行"のダイアログを表示
     */
    const showDialog = () => {
      dialogLoader.show(ForemanNewPasswordDialog, {
        params: {
          fieldId: this.state.field_id,
          // fieldTreeIdは不要
          // 施工体系図タイプ
          dialogType: DialogType.FIELD_TREE,
        },
        callback: {
          back: () => {
            dialogLoader.close();
          },
          submit: () => {
            dialogLoader.close();
          },
        },
      });
    };

    const cacheParam = this.props.view.state.cacheParam
      ? this.props.view.state.cacheParam
      : null;

    return (
      <div className='master-slide-view show'>
        <Helmet>
          <title>{HEADER_CONSTANTS.conference} - 施工体系図</title>
        </Helmet>
        <div className='master-slide-view__view'>
          <MasterPageHeader
            title='現場体制 (施工体系図)'
            onClose={() => {
              if (this.isPrimePartnerCompanyHasNodeInvited) {
                EventMg.trigger(
                  FIELD_TREE_EVENTS.SHOW_EXIT_CONFIRM_DIALOG,
                  () => {
                    _masterSlideLoader.close();
                  }
                );
              } else {
                if (getQueryStringParameter(ENTER_WORKER_FIELD_TREE_ID_PARAM_NAME)) {
                  redirectToGreenfileSagyouinEditIfFromGreenfile();
                } else {
                  _masterSlideLoader.close();
                }
              }
            }}
          />
          <div className='fieldstree-main__header'>
            <div className='fieldstree-main__menu'>
              <p>
                現場名：
                <span className='bold'>{this.state.field_data.name}</span>
              </p>
              <div className='--fx-auto' />
              <button
                className='btn-fixedsize--stay btn-show-guide'
                onClick={this.handleShowGuide}
              >
                <SchoolIcon className='icon--2x' />
                <span className='btn-show-guide__label'>この画面の使い方</span>
              </button>
            </div>
            {this.renderListCheckBox()}
            <div className='fieldstree-main__menu'>
              <ul className='btn-menu'>
                {isLoginUserPrimaryCompany() &&
                  this.renderListActionPrimeContractor()}
                {this.state.partnerCompanyCanRequest &&
                  this.renderListActionPartnerCompany()}
              </ul>
              <div className='--fx-auto' />
              {isLoginUserPrimaryCompany() && (
                <div className='fieldstree-main__end-item'>
                  {this.state.results.results}/{this.state.results.total}{' '}
                  表示数/総数
                </div>
              )}
              <button
                className='btn--sub'
                style={constructorBtnShow()}
                onClick={this.CSVExportDialog.bind(this)}
              >
                表示データをCSV出力
              </button>
              {/* ダイアログが出る */}
              {/* 権限：実行できるは元請のみ（ロールで言うなら本社管理者、支店管理者、現場監督） */}
              <PrimeContractorButton
                buttonClass='btn--sub'
                label={messageUtility.getMessage('I-001-004')}
                onClick={showDialog}
              />
            </div>
            {this.renderDescription()}
            <div className='fieldstree-main__searchform'>
              {/* 検索フォーム */}
              <div ref='searchForm' className='search-form'>
                <SearchFormHeader
                  total={this.state.results.results}
                  isShow={this.state.showForm}
                />
                <div className='search-form--sub-element search-form__item set-width-dropdown'>
                  <span className='search-form__label'>協力会社検索</span>
                  {/* 協力会社の複数選択 */}
                  <DDPartnerCompany
                    ref={e => {
                      this.DDPartnerCompany = e;
                    }}
                    callback={(...args) => {
                      EventMg.trigger(
                        PAGE_EVENT.TEMP_SEARCH_PARAM,
                        args[1],
                        args[2],
                        args[3]
                      );
                    }}
                    fieldId={this.state.field_id}
                    jvCompanyBranchId={this.state.params.jv_company_branch_id}
                    widthClass='dropdown__item--wide'
                    InfinityScrollEnable={true}
                    checked={this.state.tempParams.company_branch_ids}
                    checkedNames={this.state.tempParams.company_branch_names}
                  />
                  <button
                    className='btn-fixedsize--stay search-form__button'
                    onClick={this.handleSetSearchParam}
                    ref={this.searchButtonRef}
                  >
                    検索
                  </button>
                </div>
                <div className='search-form--sub-element'>
                  <span>絞り込み条件</span>
                  <button
                    id='accordion-toggle'
                    className={
                      this.state.showForm
                        ? 'accordion__btn'
                        : 'accordion__btn show'
                    }
                    onClick={() => this.toggleSearchForm()}
                  />
                </div>
                <div
                  className={
                    this.state.showForm ? 'accordion' : 'accordion show'
                  }
                >
                  <div className='search-form__body set-width-dropdown'>
                    <div className='form form--search-form'>
                      <div className='form__group flex-wrap'>
                        {/* 施工体制ステータス */}
                        <Status
                          approvalFlag={this.state.tempParams.approval_flag}
                        />
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>職種</span>
                          </div>
                          {/* 職種選択 */}
                          <FieldTreeJobsDropdown
                            fieldId={this.state.field_id}
                            foreignKey='jobs'
                            set={(name, value) => {
                              EventMg.trigger(
                                PAGE_EVENT.TEMP_SEARCH_PARAM,
                                name,
                                value
                              );
                            }}
                            selected={this.state.tempParams.jobs}
                            refreshFlag={this.state.refreshFlag}
                            resetRefreshFlag={this.resetRefreshFlag.bind(this)}
                            jvCompanyBranchId={
                              this.state.params.jv_company_branch_id
                            }
                          />
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>協力会社ユーザー名</span>
                          </div>
                          {/* 協力会社ユーザ(=職長)名検索 */}
                          <DDForeman
                            ref={e => {
                              this.DDForeman = e;
                            }}
                            callback={(...args) => {
                              EventMg.trigger(
                                PAGE_EVENT.TEMP_SEARCH_PARAM,
                                args[1],
                                args[2],
                                args[3]
                              );
                            }}
                            fieldId={this.state.field_id}
                            InfinityScrollEnable={true}
                            checked={this.state.tempParams.user_ids}
                            checkedNames={this.state.tempParams.user_names}
                            jvCompanyBranchId={
                              this.state.params.jv_company_branch_id
                            }
                          />
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>元請共通／元請固有</span>
                          </div>
                          <div className='form-element__element'>
                            {this.renderSelectSearchValue(
                              'joining_flag',
                              1,
                              '元請共通'
                            )}
                            {this.renderSelectSearchValue(
                              'joining_flag',
                              0,
                              '元請固有'
                            )}
                          </div>
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>管理者</span>
                          </div>
                          <div className='form-element__element'>
                            {this.renderSelectSearchValue(
                              'has_partner',
                              1,
                              '管理者あり'
                            )}
                            {this.renderSelectSearchValue(
                              'has_partner',
                              0,
                              '管理者なし'
                            )}
                          </div>
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>職長</span>
                          </div>
                          <div className='form-element__element'>
                            {this.renderSelectSearchValue(
                              'has_foreman',
                              1,
                              '職長あり'
                            )}
                            {this.renderSelectSearchValue(
                              'has_foreman',
                              0,
                              '職長なし'
                            )}
                          </div>
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>
                              1次協力会社グループの稼働状況
                            </span>
                          </div>
                          <div className='form-element__element'>
                            {this.renderSingleCheckBoxSearchValue(
                              'all_box_continue',
                              '稼動中のみのグループを表示'
                            )}
                            {this.renderSingleCheckBoxSearchValue(
                              'continue_and_finished',
                              '作業終了を含むグループを表示'
                            )}
                            {this.renderSingleCheckBoxSearchValue(
                              'all_box_finished',
                              '作業終了のみのグループを表示'
                            )}
                          </div>
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>協力会社BOX</span>
                          </div>
                          <div className='form-element__element'>
                            {this.renderSingleCheckBoxSearchValue(
                              'show_finished_box',
                              '作業終了を表示'
                            )}
                          </div>
                        </div>
                        <div className='form-element'>
                          <div className='form-element__label'>
                            <span className='label'>CCUS連携</span>
                          </div>
                          <div className='form-element__element'>
                            <div className='element__item'>
                              <label className='checkbox'>
                                <input
                                  type='checkbox'
                                  id='includeBlockedCheckbox'
                                  checked={this.state.tempParams.only_ccus_error}
                                  onChange={e => {
                                    EventMg.trigger(
                                      PAGE_EVENT.TEMP_SEARCH_PARAM,
                                      'only_ccus_error',
                                      e.target.checked
                                    );
                                  }}
                                />
                                <i
                                  className='i-square-checkbox i-2_5x'
                                  aria-hidden='true'
                                />
                                <span>エラーのみ表示</span>
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FieldTreeMain
            vw={this.props.vw}
            params={this.state.params}
            constructor={this.state.constructor}
            tree={this.state.field_trees}
            events={PAGE_EVENT}
            fieldId={this.state.field_id}
            page={this.state.page}
            login_user_contractor={this.state.login_user_contractor}
            isLoading={this.state.isLoading}
            isShowForm={this.state.showForm}
            isCcusDisplayStateFlg={
              !this.state.isBeforeCcusConnectionFlg &&
              this.state.isCcusStateActiveFlg &&
              this.state.fieldConnectionStatus
            }
            lastPage={this.state.lastPage}
            cacheParam={cacheParam}
            nodes={this.props.view.state.nodes}
            autoTaskActive={this.state.autoTaskActive}
            selectedNodes={this.state.selectedNodes}
            resetSelectedPartnerCompanyBranch={
              this.resetSelectedPartnerCompanyBranch
            }
            ccusInfo={{
              isBeforeCcusConnectionFlg: this.state.isBeforeCcusConnectionFlg,
              isCcusStateActiveFlg: this.state.isCcusStateActiveFlg,
              isCcusProcessingFlg: this.state.isCcusProcessingFlg,
              fieldConnectionStatus: this.state.fieldConnectionStatus,
              autoTaskActive: this.state.autoTaskActive,
              messageCcus: this.getCcusBlockMessage(),
              canAccessCcus: this.canAccessCcus(),
              action: {
                ccusFieldTree: this.ccusFieldTree,
              },
              mainJvCcusSecededFlag: this.state.constructor
                .main_jv_ccus_seceded_flag,
              mainJvFlag: this.state.constructor.main_jv_flag,
            }}
          />
        </div>
        <Information
          title={messageUtility.getMessage('I-000-222')}
          message={this.state.ccusErrorMessage}
          buttonText={messageUtility.getMessage('I-000-017')}
          visible={this.state.ccusErrorDialogFlg}
          onClose={() => this.closeCcusErrorDialog()}
          multilineText={true}
        />
        <Information
          title={messageUtility.getMessage('I-002-004-03')}
          message={messageUtility.getMessage('I-002-004-04')}
          buttonText={messageUtility.getMessage('I-000-011')}
          visible={this.state.displayCcusDialogFlg}
          buttonClassName='btn--effective'
          onClose={() => this.setState({ displayCcusDialogFlg: false })}
        />
        <Confirmation
          visible={this.state.isShowDialog.confirm}
          multilineText={true}
          {...this.state.dialogState}
        />
        <Information
          visible={this.state.isShowDialog.info}
          multilineText={true}
          {...this.state.dialogState}
        />
      </div>
    );
  }
}

/**
 * 協力会社絞り込み（ドロップダウンメニュー拡張）
 */
class DropdownMultiSelectPartnerCompany extends DropdownMultiSelect {
  constructor(self) {
    super(self);
  }

  setValues(values) {
    this.values = values;
  }

  setValueNames(valueNames) {
    this.valueNames = valueNames;
  }

  /**
   * テンプレート
   * @param {object} value
   * @param {bool} initDropDown: ドロップダウンの初展開フラグ
   */
  tplSelectItem(value, initDropDown) {
    let checkedValues = [];
    if (initDropDown) {
      checkedValues = this.values;
    } else {
      checkedValues = this.checked;
    }
    const f = _.filter(checkedValues, v => {
      return Number(v) === value[this.api.keyid];
    });
    const checked = f.length ? 'checked' : '';
    const keyidValue = _.escape(value[this.api.keyid]);
    const labelValue = _.escape(value[this.api.label]);
    return `<li class="${this.keyname}-select__item">
            <div class="btn-checkbox">
              <label for="${this.keyname}_select_${this.uniqueId}_${
      this.name
    }_${keyidValue}">
                <input
                  value="${keyidValue}"
                  valueName="${labelValue}"
                  id="${this.keyname}_select_${this.uniqueId}_${
      this.name
    }_${keyidValue}"
                  type="checkbox"
                  class="sys-${this.keyname}-select-item"
                  name="radio-${this.name}"
                  ${checked}>
                <!-- 注意：この<i></i>タグは<i />にするとレイアウトが崩れるのでこのまま -->
                <i class="i-square-checkbox i-2_5x" onclick="document.getElementById('${
                  this.keyname
                }_select_${this.uniqueId}_${
      this.name
    }_${keyidValue}').checked=!document.getElementById('${
      this.keyname
    }_select_${this.uniqueId}_${this.name}_${keyidValue}').checked;"></i>
              </label>
            </div>
            <div onclick="document.getElementById('${this.keyname}_select_${
      this.uniqueId
    }_${this.name}_${keyidValue}').checked=!document.getElementById('${
      this.keyname
    }_select_${this.uniqueId}_${this.name}_${keyidValue}').checked;" class="${
      this.keyname
    }-select__label">${_.escape(value.company_name)}</div>
          </li>`;
  }
}

/**
 * 協力会社絞り込みフォーム
 *
 * @props {array} checked
 * */
class DDPartnerCompany extends JSDropdownMultiSelect {
  constructor(props) {
    super(props);
    this.param = {
      name: 'company_branch_ids',
      label: '協力会社',
      apiurl: 'company_branch_id_all',
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.component.setProps(this.props);
      this.component.setValues(this.props.checked);
      this.component.setValueNames(this.props.checkedNames);
    }
  }

  displayLabel() {
    const checkedLength = this.props.checked.length;
    if (checkedLength > 0) {
      return _.join(this.props.checkedNames, ',');
    }
    return `${this.param.label}を選択`;
  }

  // ドロップダウンに表示するコンポーネントを設定
  instance(component) {
    return new DropdownMultiSelectPartnerCompany(component);
  }
}

/**
 * 職長絞り込み（ドロップダウンメニュー拡張）
 */
class DropdownMultiSelectForeman extends DropdownMultiSelect {
  constructor(self) {
    super(self);
  }

  setValues(values) {
    this.values = values;
  }

  setValueNames(valueNames) {
    this.valueNames = valueNames;
  }
}

/**
 * 職長
 */
class DDForeman extends JSDropdownMultiSelect {
  constructor(props) {
    super(props);
    this.param = {
      name: 'user_ids',
      label: 'ユーザー',
      apiurl: 'foreman_user_id',
    };
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps) !== JSON.stringify(this.props)) {
      this.component.setProps(this.props);
      this.component.setValues(this.props.checked);
      this.component.setValueNames(this.props.checkedNames);
    }
  }

  displayLabel() {
    const checkedLength = this.props.checked.length;
    if (checkedLength > 0) {
      return _.join(this.props.checkedNames, ',');
    }
    return `${this.param.label}を選択`;
  }

  // ドロップダウンに表示するコンポーネントを設定
  instance(component) {
    return new DropdownMultiSelectForeman(component);
  }
}

/**
 * 施工体制のステータス絞り込み用のコンポーネント
 *
 * @props {number}approvalFlag
 * */
class Status extends React.Component {
  constructor(props) {
    super(props);
  }

  changeApprovalFlag = e => {
    const value = Number(e.target.value);
    EventMg.trigger(PAGE_EVENT.TEMP_SEARCH_PARAM, 'approval_flag', value);
  };

  render() {
    return (
      <div className='form-element'>
        <div className='form-element__label'>
          <span className='label'>ステータス</span>
        </div>
        <div className='form-element__list'>
          <div className='element__item'>
            <label className='radio'>
              <input
                name='approval_flag'
                type='radio'
                value={0}
                checked={this.props.approvalFlag === 0}
                onChange={this.changeApprovalFlag}
              />
              <i className='i-2x' />
              <span>承認依頼前</span>
            </label>
          </div>
          <div className='element__item'>
            <label className='radio'>
              <input
                name='approval_flag'
                type='radio'
                value={1}
                checked={this.props.approvalFlag === 1}
                onChange={this.changeApprovalFlag}
              />
              <i className='i-2x' />
              <span>承認済</span>
            </label>
          </div>
          <div className='element__item'>
            <label className='radio'>
              <input
                name='approval_flag'
                type='radio'
                value={2}
                checked={this.props.approvalFlag === 2}
                onChange={this.changeApprovalFlag}
              />
              <i className='i-2x' />
              <span>元請承認待</span>
            </label>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/FieldTree.jsx